import {DeviceType, IDeviceService, OperatingSystemName, PlatformType} from "./device.service.interface";
import {PlatformDetection} from "./platform-detection";
import {makeObservable, observable, runInAction} from "mobx";
import { Clipboard } from '@awesome-cordova-plugins/clipboard';

export class DeviceService implements IDeviceService {
    constructor() {

        makeObservable<this, '_showCopyToClipboardToast'>(this, {
            _showCopyToClipboardToast: observable.ref
        });

        this._deviceDetection = new PlatformDetection();
    }


    private _showCopyToClipboardToast: boolean = false;
    get showCopyToClipboardToast(): boolean {
        return this._showCopyToClipboardToast;
    }

    set showCopyToClipboardToast(value: boolean) {
        runInAction(() => {
            this._showCopyToClipboardToast = value;
        })
    }

    async getDeviceId(): Promise<string> {
        return await this._deviceDetection.getDeviceId();
    }

    private readonly _deviceDetection: PlatformDetection;
    get deviceType(): DeviceType {
        return this._deviceDetection.deviceType;
    }

    get isIOS(): boolean {
        return this._deviceDetection.isIOS;
    }

    get isAndroid(): boolean {
        return this._deviceDetection.isAndroid;
    }

    get isWeb(): boolean {
        return this._deviceDetection.isWeb;
    }

    get isHybrid(): boolean {
        return this._deviceDetection.isHybrid;
    }

    get isMobile(): boolean {
        return this._deviceDetection.isMobile;
    }

    get isAndroidMobileHybrid(): boolean {
        return this._deviceDetection.isAndroidMobileHybrid;
    }

    getPlatformType(): PlatformType {
        if(this.isHybrid) {
            return 'hybrid';
        } else {
            return 'web';
        }
    }

    async getOperatingSystemName(): Promise<OperatingSystemName> {
        const operatingSystem = await this._deviceDetection.getOperatingSystem();


        if(operatingSystem === "unknown") {
            return 'other'
        } else {
            return operatingSystem;
        }

    }

    async copyToClipboard(text: string): Promise<void> {
        if(this.isHybrid) {
            await Clipboard.copy(text);
            if(!this.isAndroid) {
                this.showCopyToClipboardToast = true;
            }
        } else if(navigator?.clipboard) {
            await navigator.clipboard.writeText(text);
            this.showCopyToClipboardToast = true;
        }

    }

}
